import { Spinner } from '~/components/ui/spinner';

interface LoadingSpinnerProps {
  message?: string;
}

export function LoadingSpinner({ message = 'Loading...' }: LoadingSpinnerProps) {
  return (
    <output className="flex min-h-[200px] flex-col items-center justify-center gap-4">
      <Spinner className="size-6" data-testid="loading-spinner" />
      {message ? (
        <p className="text-base text-muted-foreground">{message}</p>
      ) : (
        <span className="sr-only">Loading</span>
      )}
    </output>
  );
}
